<template>
  <div
    class="aside aside-contact"
    :class="{ 'is-active': isActive }"
    @keyup.esc="toggle(false)"
  >
    <div class="aside__holder">
      <div class="aside-content">
        <div class="aside-content__body">
          <div class="aside-overflow">
            <UiTypography
              tag="h2"
              variant="header02"
              class="aside-title"
            >
              Шоурумы LITHIUM
            </UiTypography>

            <!-- <div class="aside-hero">
              <img :src="hero" alt="LITHIUM Showroom" class="aside-hero__img" />
            </div> -->

            <div class="aside-addresses">
              <hr class="aside-sep" />
              <div class="aside-address">
                <UiTypography tag="p" variant="caption">
                  г. Москва, ул. Нижняя Сыромятническая, дом 10, стр. 9, 2 этаж
                </UiTypography>
              </div>
              <hr class="aside-sep" />
              <div class="aside-address">
                <UiTypography tag="p" variant="caption">
                  г. Киров, ул. Казанская, 77б
                </UiTypography>
              </div>
              <hr class="aside-sep" />
            </div>

            <div class="aside-cta">
              <a
                class="btn btn--wa"
                :href="waLink"
                target="_blank"
                rel="noopener"
                @click="waClick"
              >
                <svg-use basic name="aside-whatsapp-white" /><span
                  >Написать в whatsapp</span
                >
              </a>
              <a
                class="btn btn--tg"
                :href="tgLink"
                target="_blank"
                rel="noopener"
              >
                <svg-use basic name="aside-telegram" /><span
                  >Написать в Telegram</span
                >
              </a>
              <a
                class="btn btn--max"
                :href="maxLink"
                target="_blank"
                rel="noopener"
              >
                <svg-use basic name="aside-max" /><span>Написать в MAX</span>
              </a>
              <a
                class="btn btn--mail"
                :href="mailLink"
                target="_blank"
                rel="noopener"
              >
                <svg-use basic name="aside-mail" /><span
                  >Написать на почту</span
                >
              </a>
              <UiOutlineButton
                class="aside-application"
                theme="dark"
                to="/application"
                full-width
              >
                Хочу персональный звонок
              </UiOutlineButton>
              <!--              <a class="btn btn&#45;&#45;call" :href="telLink">
                <svg-use basic name="aside-phone" /><span>Позвонить в LITHIUM</span>
              </a>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  UiOutlineButton,
  UiTypography
} from '@/components/common/ui'

export default {
  name: 'AsideSecond',
  components: {
    UiOutlineButton,
    UiTypography
  },
  props: {
    phone: { type: String, default: 'tel:+74951524828' },
    waNumber: { type: String, default: 'https://wa.me/74953245482' },
    tg: { type: String, default: 'https://telegram.me/lithiumhome_bot' }
  },
  computed: {
    ...mapGetters('ui', ['aside2']),
    isActive () {
      return this.$store.getters['ui/aside2'].active
    },

    hero () {
      return require('@/assets/img/aside/hero.jpg')
    },

    // ссылки
    waLink () {
      const digits = this.waNumber.replace(/[^\d]/g, '')
      return `https://wa.me/${digits}`
    },
    tgLink () {
      return this.tg
    },
    telLink () {
      return `tel:${this.phone.replace(/[^\d+]/g, '')}`
    },
    maxLink () {
      return 'https://max.ru/id4345414440_bot'
    },
    mailLink () {
      return 'mailto:artplay@lithiumhome.ru'
    }
  },
  methods: {
    toggle (val) {
      this.$store.commit(
        'ui/toggleAside2',
        typeof val === 'boolean' ? val : undefined
      )
    },
    waClick () {
      try {
        const userId = localStorage.getItem('user_id') || ''
        DSPCounter('send', {
          sid: '230574',
          site_area: 'w99MH4Ze',
          user_id: userId,
          lead_id: '',
          order_sum: ''
        })
        console.log('waClick: send DSPCounter')
      } catch (e) {
        console.warn('Ошибка DSPCounter WA:', e)
      }

      ym(88776155, 'reachGoal', 'clickwa')
      _tmr.push({ type: 'reachGoal', id: 3563947, goal: 'WA_click' })
    }
  },
  watch: {
    $route () {
      if (this.isActive) this.toggle(false)
    }
  }
}
</script>

<style lang="scss">
.aside-contact {
  display: none;
  font-family: "Helvetica", Arial, sans-serif;
  @include max-width(mobile) {
    display: block;
  }
  .aside {
    &-content {
      &__body {
        padding: 0;
      }
    }
    &-overflow {
      padding: vw(42) vw(18);
      @include max-width(mobile) {
        padding: vwm(42) vwm(18);
      }
    }
    &-title {
      margin-bottom: vw(22);
      @include max-width(mobile) {
        margin-bottom: vwm(22);
      }
    }
    &-hero__img {
      width: 100%;
      margin-bottom: vw(22);
      @include max-width(mobile) {
        margin-bottom: vwm(22);
      }
    }
    &-addresses {
      margin-bottom: vw(32);
      @include max-width(mobile) {
        margin-bottom: vwm(32);
      }
    }
    &-sep {
      margin: vw(22) 0;
      color: #cdcdcd;
      background: #cdcdcd;
      height: vw(1);
      border: 0;
      @include max-width(mobile) {
        height: vwm(1);
        margin: vwm(22) 0;
      }
    }
    &-cta {
      display: flex;
      flex-direction: column;
      gap: vw(14);
      @include max-width(mobile) {
        gap: vwm(15);
      }
    }
    &-application {
      width: 100%;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: vw(14);
    color: #ffffff;
    font-weight: 300;
    font-style: Light;
    font-size: vw(14);
    leading-trim: CAP_HEIGHT;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    text-transform: uppercase;
    min-height: vw(38);
    border: vw(1) solid transparent;
    border-radius: vw(24);
    padding: 0 vw(20);
    @include max-width(mobile) {
      gap: vwm(14);
      font-size: vwm(13);
      min-height: vwm(36);
      border-width: vwm(1);
      border-radius: vwm(18);
      padding: 0 vwm(20);
    }
    svg {
      flex: 0 0 auto;
      width: vw(24);
      height: vw(24);
      @include max-width(mobile) {
        width: vwm(21);
        height: vwm(21);
      }
    }
    &--wa {
      background: #369743;
    }
    &--tg {
      background: #2792c0;
    }
    &--max {
      background: #2d0c67;
    }
    &--call {
      background: #2e2e2e;
    }
    &--mail {
      background: #2e2e2e;
    }
  }
}
</style>
